import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import { AppRootContextProvider } from "../contexts/AppRootContext";

import AdminLayout from "./AdminLayout";
import LoggedInRoute from "../routes/ProtectedRoute/LoggedInRoute";
import LoginCheckRoute from "../routes/ProtectedRoute/LoginCheckRoute";
import Login from "../pages/Auth/Login";
import ValidateEmail from "../pages/Auth/ForgotPassword/ValidateEmail";
import ResetPassword from "../pages/Auth/ForgotPassword/ResetPassword";

const CommonLayout = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <AppRootContextProvider>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/login" />} />
        <Route exact path="/validate-email" component={ValidateEmail} />
        <Route exact path="/reset-password" component={ResetPassword} />
        <LoginCheckRoute exact path="/login" component={Login} />
        <LoggedInRoute component={AdminLayout} />
      </Switch>
    </AppRootContextProvider>
  );
}

export default CommonLayout;
